module.exports = __webpack_public_path__ + "static/media/uv_printing.c16320c4.jpg";